import { useMutation } from "@tanstack/react-query";

export interface SetParticipantFromContactParams {
  contactId: number;
  companyId: number;
  email: string;
  culture: server.dto.LCID;
  invitationSubject: string;
  invitationBody: string;
}

export const useSetContactParticipant = (documentId: number, role: server.dto.ESignParticipantRoles, onParticipantChanged: (participant: server.dto.ESignParticipant) => void) => {
  const mutation = async (params: SetParticipantFromContactParams): Promise<string | null> => {
    const { contactId, companyId, email, culture, invitationSubject, invitationBody } = params;
    const result = await window.CoreApi.ESign.SetParticipantFromContact({
      documentId,
      emailAddress: email,
      contactCulture: culture,
      contactId,
      companyId,
      role,
      invitationBody,
      invitationSubject,
    });

    const participant = result.data.data;

    if (!result.data.hasErrors) {
      onParticipantChanged(participant);
    } else {
      return result.data.errors[0].message;
    }
  };

  return useMutation({
    mutationFn: mutation,
    mutationKey: ["setContactParticipant", documentId, role],
  });
};
